(function () {
  'use strict';

  const course = {
    'milk-carton-pak-choy': {"fact":"A milk carton can start pak choy seedlings; a larger container gives growing roots more room.","question":"Who makes drainage holes in the carton?","answers":["A grown-up","A seedling","A bee"],"correct":0},
    'egg-tray-lettuce': {"fact":"Small egg-carton cells are starter homes, so seedlings need a larger container later.","question":"When a seedling outgrows its cell, what should you do?","answers":["Ask a grown-up to move it into a bigger container","Stop watering forever","Cover its leaves with mix"],"correct":0},
    'grow-dill': {"fact":"Dill has fine feathery leaves. Different herbs can have very different leaf shapes.","question":"Which tool helps you record a leaf shape?","answers":["A pencil and paper","A sealed lid","A cooking pan"],"correct":0},
    'grow-italian-parsley': {"fact":"Parsley can take time to germinate. Keep checking moisture without digging up the seeds.","question":"What should you do while waiting for parsley to sprout?","answers":["Check moisture and be patient","Dig up every seed each day","Leave the mix waterlogged"],"correct":0},
    'grow-dwarf-zinnias': {"fact":"A flower bud protects the developing flower before its petals open.","question":"What appears before an open zinnia flower?","answers":["A flower bud","A bean pod","An onion bulb"],"correct":0},
    'grow-french-marigolds': {"fact":"A small bottle planter can start marigolds, and growing roots may need a larger home.","question":"How should you watch a bee visiting a flower?","answers":["From a little distance without touching it","Catch it in your hands","Shake the flower"],"correct":0},
    'grow-a-radish-pot': {"fact":"A radish plant has leaves above the growing mix and roots below it.","question":"How do you choose the sowing depth and spacing for your radishes?","answers":["Follow the seed packet for your variety","Pack every seed into one hole","Use the colour of the pot"],"correct":0},
    'flowers-and-their-pollinators': {"fact":"Pollination moves pollen to a stigma. Seeds can develop after fertilisation.","reveals":[["Pollen","Pollen is made in anthers. A stigma receives it during pollination."],["Pollinators","Bees and other flower visitors can carry pollen on their bodies."],["Seeds","After suitable pollen arrives and fertilisation happens, seeds can develop."]],"question":"What can a bee carry between flowers that helps pollination?","answers":["Pollen","A plant pot","A garden label"],"correct":0},
    'parts-of-a-plant': { fact: 'Leaves use light to help plants make their own food.', reveals: [['Roots', 'Roots anchor a plant and take in water.'], ['Stem', 'A stem supports the plant and moves water.'], ['Leaves', 'Leaves use light to help make food.']], question: 'Which part usually takes in water from soil?', answers: ['Roots', 'Flowers', 'Petals'], correct: 0 },
    'how-a-seed-grows': { fact: 'The first little root often appears before the shoot.', reveals: [['Seed coat', 'The coat protects the tiny plant inside.'], ['First root', 'A root grows down and begins to take in water.'], ['First shoot', 'A shoot grows up towards the light.']], question: 'What often appears first when a seed sprouts?', answers: ['A flower', 'A root', 'A fruit'], correct: 1 },
    'meet-the-soil-and-the-worms': { fact: 'Earthworm tunnels help air and water move through soil.', reveals: [['Soil pieces', 'Soil contains mineral pieces of different sizes.'], ['Air and water', 'Spaces between soil pieces can hold air and water.'], ['Soil life', 'Worms and tiny living things help break down old plant material.']], question: 'Why are spaces in soil useful?', answers: ['They hold air and water', 'They make soil disappear', 'They stop roots growing'], correct: 0 },
    'water-cycle-in-your-garden': { fact: 'Water can change to vapour and later fall as rain.', reveals: [['Evaporation', 'The sun warms water and some becomes vapour.'], ['Clouds', 'Water vapour cools and forms tiny droplets.'], ['Rain', 'Droplets can fall back to the ground.']], question: 'What warms water and helps it evaporate?', answers: ['A worm', 'The sun', 'A seed'], correct: 1 },
    'why-compost': { fact: 'Compost is made as living things break down suitable organic scraps.', reveals: [['Gather', 'Collect suitable plant scraps and dry materials with an adult.'], ['Break down', 'Tiny living things help turn scraps into compost.'], ['Use', 'Finished compost can improve garden soil.']], question: 'Which belongs in a simple home compost mix?', answers: ['Plastic wrapper', 'Fruit peel', 'Metal can'], correct: 1 },
    'bean-in-a-jar': { fact: 'A bean seed can show its first root against a clear jar.', question: 'What should the paper towel feel like?', answers: ['Moist, without puddles', 'Completely dry', 'Under deep water'], correct: 0 },
    'grow-a-sunflower': { fact: 'A sunflower head is made of many small flowers.', question: 'Where should you check how deep to sow?', answers: ['The seed packet', 'The pot colour', 'The moon'], correct: 0 },
    'kangkung-in-a-bottle': { fact: 'Kangkung is a leafy vegetable also called water spinach.', question: 'What should a reused growing bottle have?', answers: ['Drainage holes made by an adult', 'A sealed bottom full of water', 'Sharp cut edges'], correct: 0 },
    'windowsill-basil-pot': { fact: 'A gentle rub of a basil leaf releases its familiar scent.', question: 'What helps a basil pot drain?', answers: ['A drainage hole and saucer', 'A sealed jar', 'Plastic over every leaf'], correct: 0 },
    'regrow-spring-onions-from-scraps': { fact: 'The white base of a spring onion can produce new green shoots.', question: 'Which part should stay when you regrow it?', answers: ['The base with roots', 'Only the green tips', 'A dry label'], correct: 0 },
    'make-a-recycled-pot': { fact: 'Drainage holes let extra water leave a plant pot.', question: 'Who makes the drainage holes?', answers: ['A grown-up', 'A young child alone', 'A pet'], correct: 0 },
    'make-seed-paper': { fact: 'Paper fibres can be pulped and formed into a new sheet.', question: 'When should seeds be added to pulp?', answers: ['After it cools, with adult help', 'While boiling', 'After the sheet is dry'], correct: 0 },
    'painted-plant-markers': { fact: 'A plant label helps you remember what was sown and when.', question: 'What useful detail can a marker show?', answers: ['Plant name and date', 'A secret password', 'The price of the pot'], correct: 0 },
    'leaf-rubbing-art': { fact: 'Leaf veins help move water and food through a leaf.', question: 'How can you see a leaf shape on paper?', answers: ['Rub a crayon gently over paper on the leaf', 'Taste the leaf', 'Cut every vein'], correct: 0 },
    'nature-observation-collage': { fact: 'Fallen leaves can have different shapes, edges and colours.', question: 'Which items are best to collect?', answers: ['Fallen, safe items with adult permission', 'Unknown berries', 'Living flowers from a neighbour'], correct: 0 }
  };

  const root = document.querySelector('[data-kids-course]');
  if (!root) return;
  const key = root.dataset.kidsCourse;
  const item = course[key];
  if (!item) return;
  const kind = root.dataset.kidsKind || 'lesson';
  const storageKey = 'growjoy-kids-course-v1:' + key;
  let state = { checks: [], choice: null, note: '' };
  try { state = { ...state, ...JSON.parse(localStorage.getItem(storageKey) || '{}') }; } catch (_) { /* Storage can be unavailable. */ }
  const save = () => { try { localStorage.setItem(storageKey, JSON.stringify(state)); } catch (_) { /* The page still works without storage. */ } };
  const shell = document.createElement('section');
  shell.className = 'kids-course';
  shell.setAttribute('aria-label', 'Interactive learning');
  root.append(shell);

  if (kind === 'lesson' && item.reveals) {
    const reveal = document.createElement('div');
    reveal.className = 'kids-course__panel';
    reveal.innerHTML = '<h2>Tap to discover</h2><p>Open each card, then look for the same idea in the lesson and in a real garden.</p>';
    const grid = document.createElement('div');
    grid.className = 'kids-course__reveal-grid';
    item.reveals.forEach(([name, detail], index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'kids-course__reveal';
      button.setAttribute('aria-expanded', 'false');
      button.innerHTML = '<span class="kids-course__reveal-number">' + (index + 1) + '</span><strong></strong><span class="kids-course__reveal-hint">Tap to reveal</span><span class="kids-course__reveal-detail" hidden></span>';
      button.querySelector('strong').textContent = name;
      button.querySelector('.kids-course__reveal-detail').textContent = detail;
      button.addEventListener('click', () => {
        const open = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(open));
        button.querySelector('.kids-course__reveal-detail').hidden = !open;
        button.querySelector('.kids-course__reveal-hint').hidden = open;
      });
      grid.append(button);
    });
    reveal.append(grid);
    shell.append(reveal);
  }

  const quiz = document.createElement('div');
  quiz.className = 'kids-course__panel kids-course__quiz';
  const title = document.createElement('h2');
  title.textContent = 'Your turn!';
  const prompt = document.createElement('p');
  prompt.textContent = item.question;
  const options = document.createElement('div');
  options.className = 'kids-course__options';
  const response = document.createElement('p');
  response.className = 'kids-course__response';
  response.setAttribute('role', 'status');
  response.setAttribute('aria-live', 'polite');
  item.answers.forEach((answer, index) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.textContent = answer;
    button.addEventListener('click', () => {
      state.choice = index;
      save();
      updateQuiz();
    });
    options.append(button);
  });
  function updateQuiz() {
    [...options.children].forEach((button, index) => {
      button.setAttribute('aria-pressed', String(state.choice === index));
      button.classList.toggle('is-correct', state.choice === index && index === item.correct);
      button.classList.toggle('is-try-again', state.choice === index && index !== item.correct);
    });
    response.textContent = state.choice === null ? 'Choose an answer to see what you discover.' : state.choice === item.correct ? 'Great thinking! You found it. ✨' : 'Good try! Look at the lesson, then choose again.';
  }
  quiz.append(title, prompt, options, response);
  shell.append(quiz);
  updateQuiz();

  // These two lesson challenges share the existing browser-only badge store.
  const badgeAPI = window.GrowJoyBadges;
  const badgeChallenge = kind === 'lesson' && badgeAPI && badgeAPI.challengeFor(key);
  if (badgeChallenge) {
    const panel = document.createElement('section');
    panel.id = 'KidsBadgeChallenge';
    panel.className = 'kids-course__panel';
    panel.style.scrollMarginTop = '24px';
    const heading = document.createElement('h2');
    heading.textContent = badgeChallenge.name + ' challenge';
    const instructions = document.createElement('p');
    instructions.textContent = 'Answer all three questions correctly to earn your sticker. You can try again as often as you like.';
    const progress = document.createElement('p');
    progress.setAttribute('role', 'status');
    progress.setAttribute('aria-live', 'polite');
    const earned = document.createElement('div');
    const sticker = document.createElement('img');
    sticker.src = badgeChallenge.badge === 'water-guardian' ? root.dataset.waterBadge : root.dataset.soilBadge;
    sticker.alt = badgeChallenge.name + ' sticker badge';
    sticker.width = 96;
    sticker.height = 96;
    sticker.style.objectFit = 'contain';
    const celebration = document.createElement('p');
    const shelfLink = document.createElement('a');
    const homeLink = document.querySelector('.kids-learning__crumb a');
    shelfLink.href = (homeLink ? homeLink.href : '/pages/kids') + '#KidsBadgesTitle';
    shelfLink.textContent = 'See your sticker badges';
    earned.append(sticker, celebration, shelfLink);
    panel.append(heading, instructions, progress);
    let currentAnswers = [];
    const savedChallenge = badgeAPI.read().activities.challenges;
    if (savedChallenge && savedChallenge[key] && Array.isArray(savedChallenge[key].answers)) currentAnswers = savedChallenge[key].answers.slice();
    let saveFailed = false;
    const rows = [];
    badgeChallenge.questions.forEach((question, questionIndex) => {
      const group = document.createElement('div');
      group.style.marginTop = '22px';
      const label = document.createElement('h3');
      label.id = 'KidsBadgeQuestion' + questionIndex;
      label.textContent = (questionIndex + 1) + '. ' + question.question;
      const choices = document.createElement('div');
      choices.className = 'kids-course__options';
      choices.setAttribute('role', 'group');
      choices.setAttribute('aria-labelledby', label.id);
      const feedback = document.createElement('p');
      feedback.className = 'kids-course__response';
      feedback.setAttribute('aria-live', 'polite');
      question.answers.forEach((answer, answerIndex) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = answer;
        button.addEventListener('click', () => {
          const result = badgeAPI.challengeAnswer(key, questionIndex, answerIndex);
          currentAnswers[questionIndex] = answerIndex;
          saveFailed = !result.saved;
          renderChallenge();
        });
        choices.append(button);
      });
      group.append(label, choices, feedback);
      panel.append(group);
      rows.push({ choices, feedback });
    });
    panel.append(earned);
    shell.append(panel);
    function renderChallenge() {
      let count = 0;
      badgeChallenge.questions.forEach((question, questionIndex) => {
        const choice = currentAnswers[questionIndex];
        const correct = choice === question.correct;
        if (correct) count++;
        [...rows[questionIndex].choices.children].forEach((button, index) => {
          button.setAttribute('aria-pressed', String(choice === index));
          button.classList.toggle('is-correct', choice === index && correct);
          button.classList.toggle('is-try-again', choice === index && !correct);
        });
        rows[questionIndex].feedback.textContent = choice === undefined ? '' : (correct ? 'You found it! ' : 'Try again. ') + question.explanation;
      });
      const hasBadge = badgeAPI.has(badgeChallenge.badge);
      progress.textContent = count + ' of 3 correct.' + (hasBadge ? ' ' + badgeChallenge.name + ' earned!' : ' Keep exploring to unlock your sticker.');
      earned.hidden = !hasBadge;
      celebration.textContent = saveFailed ? 'You earned this sticker for this visit. This browser could not save your progress.' : 'Your sticker is saved on this device. You can revisit the lesson any time.';
      if (saveFailed && !hasBadge) progress.textContent += ' This browser could not save progress; keep this page open to finish.';
    }
    renderChallenge();
  }

  if (kind !== 'lesson') {
    const materials = document.querySelectorAll('.kids-learning__checklist li');
    const progress = document.createElement('div');
    progress.className = 'kids-course__panel kids-course__progress';
    progress.innerHTML = '<h2>Get ready</h2><p>Tick the supplies you have. Ask a grown-up to help with tools and growing materials.</p>';
    const checks = document.createElement('div');
    checks.className = 'kids-course__checks';
    materials.forEach((material, index) => {
      const label = document.createElement('label');
      const input = document.createElement('input');
      input.type = 'checkbox';
      input.checked = Boolean(state.checks[index]);
      input.addEventListener('change', () => { state.checks[index] = input.checked; save(); });
      const span = document.createElement('span');
      span.textContent = material.textContent.trim();
      label.append(input, span);
      checks.append(label);
    });
    progress.append(checks);
    shell.prepend(progress);
    const journal = document.createElement('div');
    journal.className = 'kids-course__panel';
    const heading = document.createElement('h2');
    heading.textContent = kind === 'project' ? 'Grow diary' : 'My creation notes';
    const instruction = document.createElement('p');
    instruction.textContent = kind === 'project' ? 'What changed today? Draw it on paper or write a note here.' : 'What did you reuse or notice while making this?';
    const field = document.createElement('textarea');
    field.rows = 4;
    field.maxLength = 1000;
    field.setAttribute('aria-label', instruction.textContent);
    field.placeholder = 'My discovery today…';
    field.value = state.note || '';
    field.addEventListener('input', () => { state.note = field.value; save(); });
    const privacy = document.createElement('small');
    privacy.textContent = 'Saved only on this device. You can also use paper.';
    journal.append(heading, instruction, field, privacy);
    shell.append(journal);
  }

  if (!document.querySelector('.kids-learning__fact--did-you-know')) {
    const aside = document.createElement('aside');
    aside.className = 'kids-learning__fact kids-learning__fact--did-you-know';
    aside.innerHTML = '<strong>Did you know?</strong><p></p>';
    aside.querySelector('p').textContent = item.fact;
    shell.append(aside);
  }
})();
